import { useStore } from '@stores';
import { useEffect } from 'react';

export const useServiceGroup = (id: number) => {
  const { serviceGroupStore } = useStore();
  const { serviceGroup, loading } = serviceGroupStore;

  useEffect(() => {
    serviceGroupStore.get({ id });

    return () => {
      serviceGroupStore.clearServiceGroup();
    };
  }, [serviceGroupStore, id]);

  return { serviceGroup, loading };
};
